import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Text } from 'onefaceui-react-components';

import defaultFetch from 'react/api/sagas/fetch/defaultFetch';
import { formatDate, getResourceTo } from 'react/utils/utils';

import { Container } from './styles';

function LockedUserMessage(props) {
  const { user } = props;
  const [isLoading, setIsLoading] = useState(false);
  const [showingMessage, setShowingMessage] = useState(true);

  const unlockRequest = async () => {
    setIsLoading(true);
    await defaultFetch('User/Unlock', [user.id], 'POST');
    setIsLoading(false);
    setShowingMessage(false);
  };

  const handleClick = async () => {
    new Greenmile.Components.AlertModal(
      getResourceTo('users.alert.message.restore'),
      getResourceTo('users.alert.title.restore'),
      unlockRequest
    ).show();
  };

  const getMessage = () => {
    if (user?.lockDate && user?.expireDate) {
      return Monet.I18n.translateResources('users.form.message.lockAndExpire', {
        lockDate: user.lockDate,
        expireDate: user.expireDate
      });
    }

    if (user?.lockDate) {
      return getResourceTo(
        'users.form.message.lock',
        formatDate(user.lockDate)
      );
    }

    if (user?.expireDate) {
      return getResourceTo(
        'users.form.message.expire',
        formatDate(user.expireDate)
      );
    }

    return '';
  };

  if (!showingMessage) {
    return null;
  }

  return (
    <Container justifyContent="space-between" alignItems="center">
      <Text type="danger" size="sm">
        {getMessage()}
      </Text>
      <Button loading={isLoading} onClick={handleClick} variant="secondary">
        {getResourceTo('users.alert.title.restore')}
      </Button>
    </Container>
  );
}

LockedUserMessage.propTypes = {
  user: PropTypes.object.isRequired
};

export default LockedUserMessage;
